import PropTypes from 'prop-types';

// eslint-disable-next-line
export const userType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    email: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
});



// WEBPACK FOOTER //
// ./src/propTypes/accounts.js